<template>
  <!--头部-->
  <div class="header-wrapper">
    <slot></slot>
    <div v-if="showBack" class="left" @click="$router.go(-1)">
      <div class="iconfont icon-fanhui2"></div>
    </div>
    <div class="header">{{title}}</div>
    <div class="btn-wrapper">
      <Button v-for="(item,index) in btnList" :loading="item.loading" class="bkcc-btn" :type="item.btnType || 'primary'" @click="handleBtn(item.type,index)">{{item.name}}</Button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'pageHead',
    props: {
      title: {
        type: String,
      },
      btnList: {
        type: Array,
      },
      showBack:{
        type:Boolean,
        default:true
      }
    },
    methods:{
      handleBtn (type,index) {
        this.$emit('handleBtn',type,index)
      },

    },
    mounted () {

    }
  }
</script>

<style scoped lang="less">
  .header-wrapper {
    display: flex;
    line-height: 30px;
    padding: 30px 0;
    justify-content: center;
    position: relative;
    /* 返回 */
    .left {
      position: absolute;
      left: 20px;
      font-size: 22px;
      .iconfont{
        color:#999;
        font-size: 24px;
      }
    }
    .header {
      font-size: 25px;
      text-align: center;
    }
    .btn-wrapper{
      position: absolute;
      right: 20px;

    }
  }
</style>
